// Format numeric display values with comma separators while accepting raw strings or numbers.
export default function(value) {
	if (value === null || value === undefined || value === "") {
		return "";
	}

	const normalizedValue = value.toString().replace(/,/g, "");

	return normalizedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
